<template>
  <v-container>
    <h1>{{ action }} Distraction Type</h1>
    <v-form>
      <v-alert
        v-model="isError"
        dismissible
        type="error"
        transition="fade-transition"
      >
        {{ errMessage }}
      </v-alert>

      <v-text-field
        v-model="type.index"
        label="Index"
        :error-messages="errors.index"
        id="index"
        @focus="inputFocus"
      />

      <v-text-field
        v-model="type.title"
        label="Title"
        :error-messages="errors.title"
        id="title"
        @focus="inputFocus"
      />

      <v-btn
        @click="submit"
      >Save</v-btn>
    </v-form>
  </v-container>
</template>

<script>

export default {
  data: () => ({
    type: {
      index: null,
      title: null
    },

    isError: false,
    errMessage: null,
    errors: {
      index: null,
      title: null
    }
  }),
  computed: {
    action: function () {
      let id = this.$route.params.id
      if (id === 'new') {
        return 'Add'
      } else {
        return 'Edit'
      }
    }
  },
  mounted: function () {
    let id = this.$route.params.id
    // If we're making a new type, we're done
    if (id === 'new') {
      return
    }

    // Otherwise, we need to load data for the type
    var _this = this
    this.axios.get('/distractions/types/' + id)
      .then(function (res) {
        // Sanity check before assigning the value
        if (res.data.length > 0) {
          _this.type = res.data[0]
        } else {
          throw new RangeError('No distraction type information returned')
        }
      })
      .catch(this.$root.apiErrorHandler(function (msg, errors, err) {
        // If our error is a 404, that means we got a bogus type ID value and
        // we can safely abort back to the listing page. Otherwise, we want
        // to render our error message.
        if (err && err.response && err.response.status === 404) {
          return _this.$router.push('/admin/distractions')
        } else {
          _this.errMessage = msg
          _this.isError = true
        }
      }))
  },
  methods: {
    submit: function (ev) {
      var _this = this

      // Set up the proper request based on whether we're editing or creating
      let url = '/distractions/types'
      let method = 'POST'
      let id = this.$route.params.id
      if (id !== 'new') {
        url += '/' + id
        method = 'PUT'
      }

      // Now send the POST or PUT request
      this.axios.request({
        method,
        url,
        data: this.type
      })
        .then(function (res) {
          _this.$router.push('/admin/distractions')
        })
        .catch(this.$root.apiErrorHandler(function (msg, errors) {
          _this.errMessage = msg
          _this.errors = errors
          _this.isError = true
        }))
    },
    inputFocus (ev) {
      // Clear any errors for an input when it receives focus
      if (ev.target && ev.target.id) {
        this.errors[ev.target.id] = null
      }
    }
  }
}
</script>
